module.exports = __webpack_public_path__ + "grape_trolley-329d2.svg";